import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DistanceUnitPipe } from './distance-unit.pipe';
import { SpeedUnitPipe, SpeedUnitRawPipe } from './speed-unit.pipe';
import { TimeFormatPipe } from './time-format.pipe';

@NgModule({
  declarations: [DistanceUnitPipe, SpeedUnitPipe, SpeedUnitRawPipe, TimeFormatPipe],
  imports: [CommonModule],
  exports: [DistanceUnitPipe, SpeedUnitPipe, SpeedUnitRawPipe, TimeFormatPipe],
  providers: [DecimalPipe],
})
export class UnitConversionModule {}
